'use client';
import Button from '@/components/ui/button';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { getRegionalUrl } from '@/lib/utils';

export default function NotFound() {
  const params = useParams<{ countryCode?: string }>();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-5 w-full px-4 py-20">
      <Image
        src={'/assets/notfound.png'}
        alt="Not found"
        width={1000}
        height={1000}
        className="w-96 h-auto"
      />
      <h2 className="text-2xl md:text-3xl xl:text-4xl font-bold">
        404 Page Not Found
      </h2>
      <p className="font-semibold text-center text-sm md:text-base">
        The page you are looking for was moved, removed, renamed or might never
        existed.
      </p>
      <div className="flex flex-col gap-3 md:flex-row md:gap-5 items-center justify-center">
        <Link href={getRegionalUrl('/', params?.countryCode)}>
          <Button label="Return Home" variant="black" className="w-52" />
        </Link>
        <Link href={getRegionalUrl('/support', params?.countryCode)}>
          <Button
            label="Product Support"
            variant="outline"
            className="border-2 w-52"
          />
        </Link>
      </div>
    </div>
  );
}
